import React, { Component } from 'react'
import { connect } from 'react-redux'
import UserActions from '../../actions/user/user-actions'
import UIActions from '../../actions/ui/ui-actions'
import ColIndicator from '../common/ColIndicator'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import './header-cp.css'


// TODO: make this a bcio component
const BCIO_Slider = withStyles({
  root: {
    color: '#cccccc',
  },
  thumb: {
    backgroundColor: '#000000',
    border: '1.1px solid #cccccc',
    '&:focus': {
      boxShadow: '0px 0px 4px 0px #ffffff',
    },
    '&:hover, &$active': {
      boxShadow: '0px 0px 0px 1px #ffffff',
    },
  },
  rail: {
    opacity: 1.0,
  },
})(Slider);

// --- //

class HeaderCP extends Component {
  constructor() {
    super()
    this.sliderVal = 500.0
    this.sliderMin = 0.75
    this.sliderMax = 1.5
    // we want the scale of 1 to be in hte middle of the slider
    // so we need to figure the log curve
    let sliderRange = this.sliderMax - this.sliderMin
    let oneScale = (1 - this.sliderMin) / sliderRange
    let onePos = 0.5
    this.sliderLog = Math.log(oneScale) / Math.log(onePos) // I LOVE this
    this.htmlEle = document.querySelector('html')
    // this.state = {}
  }

  render() {
    let btns = []
    // ToDo: if we add another button we should proper this up a bit
    if (this.props.user.auth > 0) {
      if (this.props.activePageName !== UIActions.enums.pageNames.ADMIN) {
        btns.push(
          <div key='adminBtn' className='header-element header-indicator-item header-indicator-clickable'
            onClick={() => this.openAdminPage()}
          >
            <div className='header-indicator-label'>[ admin ]</div>
          </div>
        )
      } else {
        btns.push(
          <div key='adminBtn' className='header-element header-indicator-item'>
            <div className='header-indicator-label'>[ admin ]</div>
            <div className='indicator-contain'>
              <ColIndicator />
            </div>
          </div>
        )
      }
    }

    if (this.props.activePageName !== UIActions.enums.pageNames.OVERVIEW) {
      btns.push(
        <div key='overviewBtn' className='header-element header-indicator-item header-indicator-clickable'
          onClick={() => this.openOverview()}
        >
          <div className='header-indicator-label'>[ :== ]</div>
        </div>
      )
    } else {
      btns.push(
        <div key='overviewBtn' className='header-element header-indicator-item'>
          <div className='header-indicator-label'>[ :== ]</div>
          <div className='indicator-contain'>
            <ColIndicator />
          </div>
        </div>
      )
    }

    if (this.props.gameName) {
      if (this.props.activePageName !== UIActions.enums.pageNames.GAME) {
        btns.push(
          <div key='gameBtn' className='header-element header-indicator-item header-indicator-clickable'
            onClick={() => this.openCurrentGame()}
          >
            <div className='header-indicator-label'>{`[ ${this.props.gameName} ]`}</div>
          </div>
        )
      } else {
        btns.push(
          <div key='gameBtn' className='header-element header-indicator-item'>
            <div className='header-indicator-label'>{`[ ${this.props.gameName} ]`}</div>
            <div className='indicator-contain'>
              <ColIndicator />
            </div>
          </div>
        )
      }

      if (this.props.activePageName !== UIActions.enums.pageNames.RULES) {
        btns.push(
          <div key='rulesBtn' className='header-element header-indicator-item header-indicator-clickable'
            onClick={() => this.openRulesPage()}
          >
            <div className='header-indicator-label'>[ rules ]</div>
          </div>
        )
      } else {
        btns.push(
          <div key='rulesBtn' className='header-element header-indicator-item'>
            <div className='header-indicator-label'>[ rules ]</div>
            <div className='indicator-contain'>
              <ColIndicator />
            </div>
          </div>
        )
      }

    }

    return (
      <div className='page-header'>

        {btns}
        
        <div className='header-element indicator-able header-el-leadright header-el-leadleft'>
          <div className='header-logo'>
            -{'{'}Ludodrome{'}'}-
          </div>
        </div>
        
        <div className='header-element'>
          -
        </div>
        <div>
          <div style={{width: '10em', display: 'inline-block'}}>
            <BCIO_Slider style={{verticalAlign: 'middle'}}
              min={0} 
              max={1000}
              defaultValue={this.sliderVal}
              onChange={(e, val) => this.scaleOnChange(e, val)}
            />
          </div>
        </div>
        <div className='header-element'>
          +
        </div>
        <div className='header-element'></div>

        <div className='header-element'>{this.props.user.name}</div>
        
        <div className='header-element'>
          <button className='bcioButton' onClick={this.props.logout}>logout</button>
        </div>

      </div>
    )
  }

  scaleOnChange (e, val) {
    if (val === this.sliderVal) return
    this.sliderVal = val
    let pct = val * 0.001
    // log curve the pct
    pct = Math.pow(pct, this.sliderLog)
    // lerp
    let scale = ((this.sliderMax - this.sliderMin) * pct) + this.sliderMin
    this.htmlEle.style.setProperty('--user_scale', scale)
  }

  openAdminPage () {
    this.props.setActivePage(UIActions.enums.pageNames.ADMIN)
  }

  openOverview () {
    this.props.setActivePage(UIActions.enums.pageNames.OVERVIEW)
  }

  openCurrentGame () {
    this.props.setActivePage(UIActions.enums.pageNames.GAME)
  }

  openRulesPage () {
    this.props.setActivePage(UIActions.enums.pageNames.RULES)
  }

}

const mapStateToProps = (state) => {
  let gameName = state.game?.gameState?.meta_data?.name

  return {
    user: state.user.user,
    activePageName: state.ui.activePageName,
    gameName,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(UserActions.logout()),
    setActivePage: (pageName) => dispatch(UIActions.setActivePage(pageName)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderCP)
